/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBold: {
  name: 'bold';
  data: string;
} = {
  name: 'bold',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1A.5.5 0 0 1 4 .5h4a3.5 3.5 0 0 1 1.918 6.428A4.5 4.5 0 0 1 8 15.5H4a.5.5 0 0 1-.5-.5V1Zm1 5.5H8a2.5 2.5 0 0 0 0-5H4.5v5Zm0 1v7H8a3.5 3.5 0 1 0 0-7H4.5Z" fill="currentColor"/></svg>`,
};
